jQuery(document).ready(function ($) {
  var $filterMobile = $('.project-filter-mobile .filter-item');
  var $curtainWrapper = $('.projects-curtain-container');
  var $filterCurtain = $('.curtain-panel');
  var $dataPool = $('.projects-grids-container');
  var $mobileTarget = $('.visual-archive-container');

  var isDesktop = $curtainWrapper.is(':visible');
  var currentST = null;
  var animationTl = null;

  // INITIALIZATION SAFETY FIX:
  // Brutally eject all dormant curtain-contents from the Flexbox layout renderer globally.
  // Because they natively possess CSS `min-width: 400px`, without `display: none` they will 
  // invisibly exert massive structural pressure on the flex-row, causing incoming tabs to 
  // instantly snap violently out to 400px+ the very first time they are clicked!
  gsap.set($filterCurtain.find('.curtain-content'), { display: 'none' });

  function executeFilter(filterValue, isInitial = false) {
    if (!isInitial && animationTl && animationTl.isActive()) return;

    var $nextPanel = $filterCurtain.filter('[data-filter="' + filterValue + '"]');
    var $prevPanel = $filterCurtain.filter('.is-active');

    // Ignore redundant clicks on desktop active panel
    if (isDesktop && !isInitial && $prevPanel.length && $prevPanel.is($nextPanel)) return;

    // --- SHARED DATA FETCH ---
    var $targetGrid = $('#grid-' + filterValue);
    if (!$targetGrid.length) {
      console.warn("Grid not found for filter: " + filterValue);
      return;
    }

    // --- MOBILE LOGIC ---
    if (!isDesktop) {
      $('.projects-grid-group').hide();
      $dataPool.append($('.projects-grid-group'));

      $mobileTarget.append($targetGrid);
      $targetGrid.fadeIn(400).addClass('is-active');

      $filterMobile.removeClass('is-active');
      var $mobileActive = $filterMobile.filter('[data-filter="' + filterValue + '"]');
      $mobileActive.addClass('is-active');
      if ($mobileActive.length) {
        $mobileActive[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      updateHeroTitle(filterValue);
      // Instant scroll to top on mobile filter click
      if (!isInitial) {
        window.scrollTo(0, 0);
      }
      // Refresh ScrollTrigger to account for archive height changes
      ScrollTrigger.refresh();
      return;
    }

    // --- DESKTOP CURTAIN LOGIC ---

    // If it's the initial load, we SET the state immediately to avoid glitchy transitions
    if (isInitial) {
      $nextPanel.addClass('is-active');
      $nextPanel.prev('.curtain-tab').addClass('is-active'); // Activate sibling
      gsap.set($nextPanel, { flexGrow: 1 }); // Remove flexBasis: auto
      $nextPanel.find('.curtain-content').append($targetGrid);
      $targetGrid.show();
      gsap.set($nextPanel.find('.curtain-content'), { autoAlpha: 1, display: 'block' });
      updateHeroTitle(filterValue);
      setupPinning($nextPanel);
      return;
    }

    animationTl = gsap.timeline({
      onComplete: function () {
        // Timeline resolves after BOTH panels have gracefully slid into place empty!
        
        // NOW we inject the massive grid securely into the fully expanded new panel
        $nextPanel.find('.curtain-content').append($targetGrid);
        $targetGrid.show();
        
        // And gracefully fade it in natively!
        gsap.to($nextPanel.find('.curtain-content'), {
          autoAlpha: 1,
          display: 'block',
          duration: 0.4,
          onComplete: () => {
            setupPinning($nextPanel);
          }
        });
      }
    });

    // 1. If there's an active panel, immediately safely eject the grid to prevent squishing layout thrashing
    if ($prevPanel.length) {
      $prevPanel.removeClass('is-active');
      $prevPanel.prev('.curtain-tab').removeClass('is-active'); // Deactivate sibling tab
      
      // Instantly stash the heavy grid back into the safe invisible pool
      $dataPool.append($prevPanel.find('.projects-grid-group').hide());
      
      // Kill the physical layout footprint entirely
      gsap.set($prevPanel.find('.curtain-content'), { display: 'none', autoAlpha: 0 });

      // Animate the actual empty shell shrinking simultaneously with the new panel growing to strictly 0!
      animationTl.to($prevPanel, {
        flexGrow: 0,
        duration: 0.8,
        ease: "power3.inOut"
      }, 0); // Start precisely at time 0
    }

    // 2. Prepare next panel (but keep it EMPTY during the stretch!)
    animationTl.add(function () {
      $nextPanel.addClass('is-active');
      $nextPanel.prev('.curtain-tab').addClass('is-active'); // Activate sibling tab
      
      // We do NOT inject the grid yet so the panel is completely empty and expands absolutely friction-free!
      updateHeroTitle(filterValue);
    }, 0); 

    // 3. Animate new panel opening as an absolutely empty shell!
    animationTl.to($nextPanel, {
      flexGrow: 1,
      duration: 0.8,
      ease: "power3.inOut"
    }, 0); // Start aggressively growing exactly at time 0
  }

  function setupPinning($panel) {
    if (currentST) {
      currentST.kill();
      gsap.set($curtainWrapper, { clearProps: "all" });
      currentST = null;
    }

    var $content = $panel.find('.curtain-content');
    var $grid = $content.find('.projects-grid-group');
    if (!$grid.length) return;

    var viewportH = window.innerHeight;
    var contentH = $grid.outerHeight(true) + 24; // 24 is gp-y
    var scrollDist = Math.max(0, contentH - viewportH);

    if (scrollDist > 0) {
      currentST = ScrollTrigger.create({
        trigger: $curtainWrapper,
        start: "top top",
        end: "+=" + scrollDist,
        pin: true,
        scrub: true,
        onUpdate: (self) => {
          gsap.set($content, { y: -self.progress * scrollDist });
        },
        refreshPriority: -1
      });
    } else {
      currentST = ScrollTrigger.create({
        trigger: $curtainWrapper,
        start: "top top",
        end: "bottom top",
        pin: true,
        refreshPriority: -1
      });
    }
    ScrollTrigger.refresh();
  }

  function updateHeroTitle(filterValue) {
    var $titleEl = $('.hero h2');
    if (!$titleEl.length) return;

    if (filterValue === 'all') {
      $titleEl.html('All<br>Projects');
    } else {
      var categoryName = $filterMobile.filter('[data-filter="' + filterValue + '"]').text().trim();
      if (!categoryName) {
        categoryName = $('.curtain-panel[data-filter="' + filterValue + '"] .curtain-tab h3').text().trim();
      }
      $titleEl.html(categoryName + '<br>Projects');
    }
  }

  $('.curtain-tab').on('click', function () {
    var filter = $(this).next('.curtain-panel').data('filter');
    executeFilter(filter);
  });

  $filterMobile.on('click', function (e) {
    e.preventDefault();
    executeFilter($(this).data('filter'));
  });

  $(window).on('resize', function () {
    var nowIsDesktop = $curtainWrapper.is(':visible');
    if (nowIsDesktop !== isDesktop) {
      location.reload();
    }
  });

  function setupMobileSticky() {
    if (isDesktop) return;

    var $filter = $('.projects-filter');
    var $archive = $('.projects-archive');

    if (!$filter.length || !$archive.length) return;

    // Pin ONLY the Filter directly flush with the top edge of the screen
    ScrollTrigger.create({
      trigger: $filter,
      start: "top top",
      endTrigger: $archive,
      end: "bottom top+=" + $filter.outerHeight(),
      pin: true,
      pinSpacing: false, // Extremely critical: stops GSAP from forcing the archive mathematically off-screen!
      anticipatePin: 1
    });
  }

  // INITIAL LOAD - Force explicit initial state
  executeFilter('all', true);
  setupMobileSticky();
});
